// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
import { loadStripe } from '@stripe/stripe-js'

// @ts-ignore
export const stripePromise = loadStripe(window.StripePublishableKey)
